import classNames from 'classnames'
import PropTypes from 'prop-types'

const FilterButton = ({ id, onClick, text, icon, isActive = false }) => (
  <button id={id} onClick={onClick} className={classNames('btn-tab', { active: isActive, 'd-inline-flex align-items-center': !!icon })}>
    {icon}
    {text}
  </button>
)

FilterButton.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.node,
  isActive: PropTypes.bool,
}

export default FilterButton
